// GENERIERT von scripts/gen-registry.ts – nicht bearbeiten, nicht einchecken.
import type { ModuleManifest } from './contract'
import m_assistant from '../modules/assistant/module'
import m_deposits from '../modules/deposits/module'
import m_einvoice from '../modules/einvoice/module'
import m_finance from '../modules/finance/module'
import m_inventory from '../modules/inventory/module'
import m_masterdata from '../modules/masterdata/module'
import m_platform from '../modules/platform/module'
import m_pos from '../modules/pos/module'
import m_pricing from '../modules/pricing/module'
import m_purchasing from '../modules/purchasing/module'
import m_reporting from '../modules/reporting/module'
import m_sales from '../modules/sales/module'
import m_stocktaking from '../modules/stocktaking/module'
import * as c_assistant from '../modules/assistant/contract'
import * as c_deposits from '../modules/deposits/contract'
import * as c_einvoice from '../modules/einvoice/contract'
import * as c_finance from '../modules/finance/contract'
import * as c_inventory from '../modules/inventory/contract'
import * as c_masterdata from '../modules/masterdata/contract'
import * as c_platform from '../modules/platform/contract'
import * as c_pos from '../modules/pos/contract'
import * as c_pricing from '../modules/pricing/contract'
import * as c_purchasing from '../modules/purchasing/contract'
import * as c_reporting from '../modules/reporting/contract'
import * as c_sales from '../modules/sales/contract'
import * as c_stocktaking from '../modules/stocktaking/contract'

/** Alle Aktionsverträge nach Namen – Grundlage des typisierten Clients (api.call('…', input)). */
export const actionContracts = {
  'assistant.conversation.delete': c_assistant.conversationDelete,
  'assistant.conversation.get': c_assistant.conversationGet,
  'assistant.conversation.list': c_assistant.conversationList,
  'assistant.conversation.rename': c_assistant.conversationRename,
  'assistant.notice.get': c_assistant.noticeGet,
  'assistant.settings.get': c_assistant.settingsGet,
  'assistant.settings.update': c_assistant.settingsUpdate,
  'assistant.suggestion.list': c_assistant.suggestionList,
  'deposits.account.adjust': c_deposits.accountAdjust,
  'deposits.account.list': c_deposits.accountList,
  'deposits.account.statement': c_deposits.accountStatement,
  'deposits.adjustment.discard': c_deposits.adjustmentDiscard,
  'deposits.adjustment.get': c_deposits.adjustmentGet,
  'deposits.adjustment.list': c_deposits.adjustmentList,
  'deposits.adjustment.post': c_deposits.adjustmentPost,
  'deposits.adjustment.print': c_deposits.adjustmentPrint,
  'deposits.adjustment.reverse': c_deposits.adjustmentReverse,
  'deposits.adjustment.saveDraft': c_deposits.adjustmentSaveDraft,
  'deposits.adjustment.transition': c_deposits.adjustmentTransition,
  'deposits.customerReturn.book': c_deposits.customerReturnBook,
  'deposits.customerReturn.discard': c_deposits.customerReturnDiscard,
  'deposits.customerReturn.get': c_deposits.customerReturnGet,
  'deposits.customerReturn.list': c_deposits.customerReturnList,
  'deposits.customerReturn.post': c_deposits.customerReturnPost,
  'deposits.customerReturn.print': c_deposits.customerReturnPrint,
  'deposits.customerReturn.quote': c_deposits.returnQuote,
  'deposits.customerReturn.reverse': c_deposits.customerReturnReverse,
  'deposits.customerReturn.saveDraft': c_deposits.customerReturnSaveDraft,
  'deposits.customerReturn.transition': c_deposits.customerReturnTransition,
  'deposits.stock.list': c_deposits.emptiesStock,
  'deposits.supplierAdjustment.discard': c_deposits.supplierAdjustmentDiscard,
  'deposits.supplierAdjustment.get': c_deposits.supplierAdjustmentGet,
  'deposits.supplierAdjustment.list': c_deposits.supplierAdjustmentList,
  'deposits.supplierAdjustment.post': c_deposits.supplierAdjustmentPost,
  'deposits.supplierAdjustment.print': c_deposits.supplierAdjustmentPrint,
  'deposits.supplierAdjustment.reverse': c_deposits.supplierAdjustmentReverse,
  'deposits.supplierAdjustment.saveDraft': c_deposits.supplierAdjustmentSaveDraft,
  'deposits.supplierAdjustment.transition': c_deposits.supplierAdjustmentTransition,
  'deposits.supplierReturn.book': c_deposits.supplierReturnBook,
  'deposits.supplierReturn.discard': c_deposits.supplierReturnDiscard,
  'deposits.supplierReturn.get': c_deposits.supplierReturnGet,
  'deposits.supplierReturn.list': c_deposits.supplierReturnList,
  'deposits.supplierReturn.post': c_deposits.supplierReturnPost,
  'deposits.supplierReturn.print': c_deposits.supplierReturnPrint,
  'deposits.supplierReturn.reverse': c_deposits.supplierReturnReverse,
  'deposits.supplierReturn.saveDraft': c_deposits.supplierReturnSaveDraft,
  'deposits.supplierReturn.transition': c_deposits.supplierReturnTransition,
  'deposits.type.create': c_deposits.depositTypeCreate,
  'deposits.type.deactivate': c_deposits.depositTypeDeactivate,
  'deposits.type.get': c_deposits.depositTypeGet,
  'deposits.type.list': c_deposits.depositTypeList,
  'deposits.type.reactivate': c_deposits.depositTypeReactivate,
  'deposits.type.setComponents': c_deposits.depositTypeSetComponents,
  'deposits.type.setRate': c_deposits.depositTypeSetRate,
  'deposits.type.update': c_deposits.depositTypeUpdate,
  'einvoice.inbound.assignSupplier': c_einvoice.inboundAssignSupplier,
  'einvoice.inbound.capture': c_einvoice.inboundCapture,
  'einvoice.inbound.get': c_einvoice.inboundGet,
  'einvoice.inbound.import': c_einvoice.inboundImport,
  'einvoice.inbound.list': c_einvoice.inboundList,
  'einvoice.inbound.mapLine': c_einvoice.inboundMapLine,
  'einvoice.inbound.match': c_einvoice.inboundMatchContract,
  'einvoice.inbound.reject': c_einvoice.inboundReject,
  'einvoice.inbound.reparse': c_einvoice.inboundReparse,
  'einvoice.outbound.download': c_einvoice.outboundDownload,
  'einvoice.outbound.get': c_einvoice.outboundGet,
  'einvoice.outbound.issue': c_einvoice.outboundIssue,
  'einvoice.outbound.list': c_einvoice.outboundList,
  'einvoice.outbound.markSent': c_einvoice.outboundMarkSent,
  'einvoice.outbound.preflight': c_einvoice.outboundPreflight,
  'einvoice.outbound.preflightDraft': c_einvoice.outboundPreflightDraft,
  'einvoice.outbound.suppressReversal': c_einvoice.outboundSuppressReversal,
  'einvoice.settings.get': c_einvoice.settingsGet,
  'einvoice.settings.update': c_einvoice.settingsUpdate,
  'finance.account.applyTemplate': c_finance.accountApplyTemplate,
  'finance.account.mapping': c_finance.accountMappingGet,
  'finance.account.set': c_finance.accountMappingSet,
  'finance.automation.get': c_finance.financeAutomationGet,
  'finance.automation.update': c_finance.financeAutomationUpdate,
  'finance.bank.accountList': c_finance.bankAccountList,
  'finance.bank.accountSave': c_finance.bankAccountSave,
  'finance.bank.book': c_finance.bankBook,
  'finance.bank.confirm': c_finance.bankConfirm,
  'finance.bank.confirmMany': c_finance.bankConfirmMany,
  'finance.bank.statementImport': c_finance.bankStatementImport,
  'finance.bank.statementList': c_finance.bankStatementList,
  'finance.bank.transactionGet': c_finance.bankTransactionGet,
  'finance.bank.transactionList': c_finance.bankTransactionList,
  'finance.bank.unmatch': c_finance.bankUnmatch,
  'finance.channel.invoice': c_finance.financeChannelInvoice,
  'finance.channel.invoices': c_finance.financeChannelInvoices,
  'finance.creditNote.correct': c_finance.creditNoteCorrect,
  'finance.creditNote.derive': c_finance.creditNoteDerive,
  'finance.creditNote.discard': c_finance.creditNoteDiscard,
  'finance.creditNote.get': c_finance.creditNoteGet,
  'finance.creditNote.list': c_finance.creditNoteList,
  'finance.creditNote.pdf': c_finance.creditNotePdf,
  'finance.creditNote.post': c_finance.creditNotePost,
  'finance.creditNote.print': c_finance.creditNotePrint,
  'finance.creditNote.reverse': c_finance.creditNoteReverse,
  'finance.creditNote.saveDraft': c_finance.creditNoteSaveDraft,
  'finance.creditNote.send': c_finance.creditNoteSend,
  'finance.creditNote.sendPreview': c_finance.creditNoteSendPreview,
  'finance.creditNote.transition': c_finance.creditNoteTransition,
  'finance.driverCash.approve': c_finance.driverCashApprove,
  'finance.driverCash.get': c_finance.driverCashGet,
  'finance.driverCash.list': c_finance.driverCashList,
  'finance.driverCash.open': c_finance.driverCashOpen,
  'finance.driverCash.reject': c_finance.driverCashReject,
  'finance.driverCash.submit': c_finance.driverCashSubmit,
  'finance.dunning.blockLift': c_finance.dunningBlockLift,
  'finance.dunning.blocks': c_finance.dunningBlocks,
  'finance.dunning.blockSet': c_finance.dunningBlockSet,
  'finance.dunning.cancelRun': c_finance.dunningCancelRun,
  'finance.dunning.notice': c_finance.dunningNotice,
  'finance.dunning.notices': c_finance.dunningNotices,
  'finance.dunning.propose': c_finance.dunningPropose,
  'finance.dunning.run': c_finance.dunningRun,
  'finance.dunning.sendNotice': c_finance.dunningSendNotice,
  'finance.dunning.sendPreview': c_finance.dunningSendPreview,
  'finance.dunning.sendRun': c_finance.dunningSendRun,
  'finance.dunning.sendTargets': c_finance.dunningSendTargets,
  'finance.dunning.settingsGet': c_finance.dunningSettingsGet,
  'finance.dunning.settingsUpdate': c_finance.dunningSettingsUpdate,
  'finance.export.list': c_finance.exportList,
  'finance.export.partners': c_finance.exportPartners,
  'finance.export.run': c_finance.exportRun,
  'finance.export.settingsUpdate': c_finance.exportSettingsUpdate,
  'finance.export.validate': c_finance.exportValidate,
  'finance.invoice.derive': c_finance.invoiceDerive,
  'finance.invoice.discard': c_finance.invoiceDiscard,
  'finance.invoice.get': c_finance.invoiceGet,
  'finance.invoice.list': c_finance.invoiceList,
  'finance.invoice.pdf': c_finance.invoicePdf,
  'finance.invoice.post': c_finance.invoicePost,
  'finance.invoice.print': c_finance.invoicePrint,
  'finance.invoice.rectify': c_finance.invoiceRectify,
  'finance.invoice.reverse': c_finance.invoiceReverse,
  'finance.invoice.saveDraft': c_finance.invoiceSaveDraft,
  'finance.invoice.send': c_finance.invoiceSend,
  'finance.invoice.sendMany': c_finance.invoiceSendMany,
  'finance.invoice.sendPreview': c_finance.invoiceSendPreview,
  'finance.invoice.sendTargets': c_finance.invoiceSendTargets,
  'finance.invoice.status': c_finance.invoiceStatus,
  'finance.invoice.transition': c_finance.invoiceTransition,
  'finance.invoiceRun.post': c_finance.invoiceRunPost,
  'finance.invoiceRun.preview': c_finance.invoiceRunPreview,
  'finance.journal.list': c_finance.journalList,
  'finance.openItem.account': c_finance.openItemAccount,
  'finance.openItem.list': c_finance.openItemList,
  'finance.openItem.offset': c_finance.openItemOffset,
  'finance.openItem.summary': c_finance.openItemSummary,
  'finance.openItem.writeOff': c_finance.openItemWriteOff,
  'finance.overview.invoicesToIssue': c_finance.invoicesToIssue,
  'finance.overview.overdueReceivables': c_finance.overdueReceivables,
  'finance.overview.payablesDue': c_finance.payablesDue,
  'finance.payable.pay': c_finance.payablePay,
  'finance.payable.paymentList': c_finance.payablePaymentList,
  'finance.payable.proposal': c_finance.payableProposal,
  'finance.payment.allocate': c_finance.paymentAllocate,
  'finance.payment.get': c_finance.paymentGet,
  'finance.payment.list': c_finance.paymentList,
  'finance.payment.record': c_finance.paymentRecord,
  'finance.payment.reverse': c_finance.paymentReverse,
  'finance.payment.suggest': c_finance.paymentSuggest,
  'finance.period.close': c_finance.periodClose,
  'finance.period.reopen': c_finance.periodReopen,
  'finance.period.status': c_finance.periodStatus,
  'finance.rectification.post': c_finance.rectificationPost,
  'inventory.adjustment.approve': c_inventory.adjustmentApprove,
  'inventory.adjustment.book': c_inventory.adjustmentBook,
  'inventory.adjustment.discard': c_inventory.adjustmentDiscard,
  'inventory.adjustment.get': c_inventory.adjustmentGet,
  'inventory.adjustment.list': c_inventory.adjustmentList,
  'inventory.adjustment.post': c_inventory.adjustmentPost,
  'inventory.adjustment.print': c_inventory.adjustmentPrint,
  'inventory.adjustment.reject': c_inventory.adjustmentReject,
  'inventory.adjustment.reverse': c_inventory.adjustmentReverse,
  'inventory.adjustment.saveDraft': c_inventory.adjustmentSaveDraft,
  'inventory.adjustment.transition': c_inventory.adjustmentTransition,
  'inventory.approval.state': c_inventory.approvalState,
  'inventory.bin.move': c_inventory.binMove,
  'inventory.bin.moveReverse': c_inventory.binMoveReverse,
  'inventory.bin.moves': c_inventory.binMoves,
  'inventory.bin.stock': c_inventory.binStock,
  'inventory.document.locate': c_inventory.documentLocate,
  'inventory.lot.block': c_inventory.lotBlock,
  'inventory.lot.critical': c_inventory.lotCriticalCount,
  'inventory.lot.get': c_inventory.lotGet,
  'inventory.lot.list': c_inventory.lotList,
  'inventory.lot.recall': c_inventory.lotRecall,
  'inventory.lot.release': c_inventory.lotRelease,
  'inventory.receipt.approve': c_inventory.receiptApprove,
  'inventory.receipt.derive': c_inventory.receiptDerive,
  'inventory.receipt.discard': c_inventory.receiptDiscard,
  'inventory.receipt.get': c_inventory.receiptGet,
  'inventory.receipt.list': c_inventory.receiptList,
  'inventory.receipt.post': c_inventory.receiptPost,
  'inventory.receipt.print': c_inventory.receiptPrint,
  'inventory.receipt.receive': c_inventory.receiptReceive,
  'inventory.receipt.reject': c_inventory.receiptReject,
  'inventory.receipt.reverse': c_inventory.receiptReverse,
  'inventory.receipt.saveDraft': c_inventory.receiptSaveDraft,
  'inventory.receipt.transition': c_inventory.receiptTransition,
  'inventory.stock.item': c_inventory.stockItem,
  'inventory.stock.journal': c_inventory.stockJournal,
  'inventory.stock.list': c_inventory.stockList,
  'inventory.transfer.approve': c_inventory.transferApprove,
  'inventory.transfer.cancel': c_inventory.transferCancel,
  'inventory.transfer.detail': c_inventory.transferDetail,
  'inventory.transfer.discard': c_inventory.transferDiscard,
  'inventory.transfer.list': c_inventory.transferList,
  'inventory.transfer.locations': c_inventory.transferLocations,
  'inventory.transfer.picking': c_inventory.transferPicking,
  'inventory.transfer.print': c_inventory.transferPrint,
  'inventory.transfer.propose': c_inventory.transferPropose,
  'inventory.transfer.receive': c_inventory.transferReceive,
  'inventory.transfer.reject': c_inventory.transferReject,
  'inventory.transfer.request': c_inventory.transferRequest,
  'inventory.transfer.reverse': c_inventory.transferReverse,
  'inventory.transfer.settle': c_inventory.transferSettle,
  'inventory.transfer.ship': c_inventory.transferShip,
  'inventory.transfer.todo': c_inventory.transferTodoCount,
  'inventory.transferReceipt.reverse': c_inventory.transferReceiptReverse,
  'masterdata.barcode.add': c_masterdata.barcodeAdd,
  'masterdata.barcode.remove': c_masterdata.barcodeRemove,
  'masterdata.barcode.resolve': c_masterdata.barcodeResolve,
  'masterdata.bin.create': c_masterdata.binCreate,
  'masterdata.bin.deactivate': c_masterdata.binDeactivate,
  'masterdata.bin.list': c_masterdata.binList,
  'masterdata.bin.reactivate': c_masterdata.binReactivate,
  'masterdata.bin.update': c_masterdata.binUpdate,
  'masterdata.catalog.groups': c_masterdata.catalogGroups,
  'masterdata.catalog.items': c_masterdata.catalogItems,
  'masterdata.customer.account': c_masterdata.customerAccount,
  'masterdata.customer.create': c_masterdata.customerCreate,
  'masterdata.customer.deactivate': c_masterdata.customerDeactivate,
  'masterdata.customer.get': c_masterdata.customerGet,
  'masterdata.customer.list': c_masterdata.customerList,
  'masterdata.customer.reactivate': c_masterdata.customerReactivate,
  'masterdata.customer.update': c_masterdata.customerUpdate,
  'masterdata.customer.upsert': c_masterdata.customerUpsert,
  'masterdata.history.list': c_masterdata.historyList,
  'masterdata.item.create': c_masterdata.itemCreate,
  'masterdata.item.deactivate': c_masterdata.itemDeactivate,
  'masterdata.item.get': c_masterdata.itemGet,
  'masterdata.item.list': c_masterdata.itemList,
  'masterdata.item.lookup': c_masterdata.itemLookup,
  'masterdata.item.prices': c_masterdata.itemPrices,
  'masterdata.item.reactivate': c_masterdata.itemReactivate,
  'masterdata.item.setImages': c_masterdata.itemSetImages,
  'masterdata.item.setUnits': c_masterdata.itemSetUnits,
  'masterdata.item.stock': c_masterdata.itemStock,
  'masterdata.item.update': c_masterdata.itemUpdate,
  'masterdata.item.upsert': c_masterdata.itemUpsert,
  'masterdata.itemGroup.create': c_masterdata.itemGroupCreate,
  'masterdata.itemGroup.deactivate': c_masterdata.itemGroupDeactivate,
  'masterdata.itemGroup.get': c_masterdata.itemGroupGet,
  'masterdata.itemGroup.list': c_masterdata.itemGroupList,
  'masterdata.itemGroup.reactivate': c_masterdata.itemGroupReactivate,
  'masterdata.itemGroup.update': c_masterdata.itemGroupUpdate,
  'masterdata.itemLocation.list': c_masterdata.itemLocationList,
  'masterdata.itemLocation.set': c_masterdata.itemLocationSet,
  'masterdata.itemSupplier.end': c_masterdata.itemSupplierEnd,
  'masterdata.itemSupplier.list': c_masterdata.itemSupplierList,
  'masterdata.itemSupplier.set': c_masterdata.itemSupplierSet,
  'masterdata.location.create': c_masterdata.locationCreate,
  'masterdata.location.deactivate': c_masterdata.locationDeactivate,
  'masterdata.location.get': c_masterdata.locationGet,
  'masterdata.location.list': c_masterdata.locationList,
  'masterdata.location.reactivate': c_masterdata.locationReactivate,
  'masterdata.location.update': c_masterdata.locationUpdate,
  'masterdata.partner.locate': c_masterdata.partnerLocate,
  'masterdata.partner.lookup': c_masterdata.partnerLookup,
  'masterdata.paymentTerm.create': c_masterdata.paymentTermCreate,
  'masterdata.paymentTerm.deactivate': c_masterdata.paymentTermDeactivate,
  'masterdata.paymentTerm.get': c_masterdata.paymentTermGet,
  'masterdata.paymentTerm.list': c_masterdata.paymentTermList,
  'masterdata.paymentTerm.reactivate': c_masterdata.paymentTermReactivate,
  'masterdata.paymentTerm.update': c_masterdata.paymentTermUpdate,
  'masterdata.reasonCode.create': c_masterdata.reasonCodeCreate,
  'masterdata.reasonCode.deactivate': c_masterdata.reasonCodeDeactivate,
  'masterdata.reasonCode.get': c_masterdata.reasonCodeGet,
  'masterdata.reasonCode.list': c_masterdata.reasonCodeList,
  'masterdata.reasonCode.reactivate': c_masterdata.reasonCodeReactivate,
  'masterdata.reasonCode.update': c_masterdata.reasonCodeUpdate,
  'masterdata.reference.options': c_masterdata.referenceOptions,
  'masterdata.supplier.account': c_masterdata.supplierAccount,
  'masterdata.supplier.create': c_masterdata.supplierCreate,
  'masterdata.supplier.deactivate': c_masterdata.supplierDeactivate,
  'masterdata.supplier.get': c_masterdata.supplierGet,
  'masterdata.supplier.list': c_masterdata.supplierList,
  'masterdata.supplier.reactivate': c_masterdata.supplierReactivate,
  'masterdata.supplier.update': c_masterdata.supplierUpdate,
  'masterdata.supplier.upsert': c_masterdata.supplierUpsert,
  'masterdata.taxCode.create': c_masterdata.taxCodeCreate,
  'masterdata.taxCode.deactivate': c_masterdata.taxCodeDeactivate,
  'masterdata.taxCode.get': c_masterdata.taxCodeGet,
  'masterdata.taxCode.list': c_masterdata.taxCodeList,
  'masterdata.taxCode.reactivate': c_masterdata.taxCodeReactivate,
  'masterdata.taxCode.update': c_masterdata.taxCodeUpdate,
  'masterdata.taxRate.add': c_masterdata.taxRateAdd,
  'masterdata.taxRate.remove': c_masterdata.taxRateRemove,
  'masterdata.unit.create': c_masterdata.unitCreate,
  'masterdata.unit.deactivate': c_masterdata.unitDeactivate,
  'masterdata.unit.get': c_masterdata.unitGet,
  'masterdata.unit.list': c_masterdata.unitList,
  'masterdata.unit.reactivate': c_masterdata.unitReactivate,
  'masterdata.unit.update': c_masterdata.unitUpdate,
  'platform.apiAccount.create': c_platform.technicalAccountCreate,
  'platform.apiToken.create': c_platform.apiTokenCreate,
  'platform.apiToken.revoke': c_platform.apiTokenRevoke,
  'platform.assistantActions.list': c_platform.assistantActionCatalog,
  'platform.audit.export': c_platform.auditExport,
  'platform.audit.facets': c_platform.auditFacets,
  'platform.audit.list': c_platform.auditList,
  'platform.audit.seal': c_platform.auditSeal,
  'platform.company.get': c_platform.companyGet,
  'platform.company.update': c_platform.companyUpdate,
  'platform.customField.definitions': c_platform.customFieldAdminList,
  'platform.customField.list': c_platform.customFieldList,
  'platform.customField.save': c_platform.customFieldSave,
  'platform.document.locate': c_platform.documentLocate,
  'platform.feature.list': c_platform.featureList,
  'platform.feature.set': c_platform.featureSet,
  'platform.import.list': c_platform.importList,
  'platform.import.preview': c_platform.importPreview,
  'platform.import.run': c_platform.importRun,
  'platform.import.runs': c_platform.importRuns,
  'platform.import.status': c_platform.importStatus,
  'platform.integration.overview': c_platform.integrationOverview,
  'platform.mail.cancel': c_platform.mailCancel,
  'platform.mail.forEntity': c_platform.mailForEntity,
  'platform.mail.get': c_platform.mailGet,
  'platform.mail.list': c_platform.mailList,
  'platform.mail.markUndeliverable': c_platform.mailMarkUndeliverable,
  'platform.mail.resend': c_platform.mailResend,
  'platform.mail.sender.list': c_platform.mailSenderList,
  'platform.mail.sender.remove': c_platform.mailSenderRemove,
  'platform.mail.sender.save': c_platform.mailSenderSave,
  'platform.mail.sender.test': c_platform.mailSenderTest,
  'platform.mail.settings.get': c_platform.mailSettingsGet,
  'platform.mail.settings.update': c_platform.mailSettingsUpdate,
  'platform.mail.status': c_platform.mailStatus,
  'platform.mail.suppression.add': c_platform.mailSuppressionAdd,
  'platform.mail.suppression.lift': c_platform.mailSuppressionLift,
  'platform.mail.suppression.list': c_platform.mailSuppressionList,
  'platform.mail.template.get': c_platform.mailTemplateGet,
  'platform.mail.template.list': c_platform.mailTemplateList,
  'platform.mail.template.preview': c_platform.mailTemplatePreview,
  'platform.mail.template.reset': c_platform.mailTemplateReset,
  'platform.mail.template.save': c_platform.mailTemplateSave,
  'platform.mailInbox.get': c_platform.mailInboxGet,
  'platform.mailInbox.importEml': c_platform.mailInboxImportEml,
  'platform.mailInbox.messages': c_platform.mailInboxMessages,
  'platform.mailInbox.test': c_platform.mailInboxTest,
  'platform.mailInbox.update': c_platform.mailInboxUpdate,
  'platform.notification.list': c_platform.notificationList,
  'platform.notification.markAllRead': c_platform.notificationMarkAllRead,
  'platform.notification.markRead': c_platform.notificationMarkRead,
  'platform.numberRange.list': c_platform.numberRangeList,
  'platform.numberRange.update': c_platform.numberRangeUpdate,
  'platform.operations.status': c_platform.operationsStatus,
  'platform.privacy.erasePartner': c_platform.privacyErasePartner,
  'platform.privacy.memberReport': c_platform.privacyMemberReport,
  'platform.privacy.partners': c_platform.privacyPartners,
  'platform.profile.clearPin': c_platform.profileClearPin,
  'platform.profile.get': c_platform.profileGet,
  'platform.profile.mailPreferences': c_platform.profileMailPreferences,
  'platform.profile.pushSettings': c_platform.profilePushSettings,
  'platform.profile.registerPushDevice': c_platform.profileRegisterPushDevice,
  'platform.profile.requestDeletion': c_platform.profileRequestDeletion,
  'platform.profile.security': c_platform.profileSecurity,
  'platform.profile.setMailPreference': c_platform.profileSetMailPreference,
  'platform.profile.setPin': c_platform.profileSetPin,
  'platform.profile.setPushCategory': c_platform.profileSetPushCategory,
  'platform.profile.unregisterPushDevice': c_platform.profileUnregisterPushDevice,
  'platform.profile.update': c_platform.profileUpdate,
  'platform.role.change': c_platform.roleChange,
  'platform.role.create': c_platform.roleCreate,
  'platform.role.list': c_platform.roleList,
  'platform.role.remove': c_platform.roleRemove,
  'platform.role.update': c_platform.roleUpdate,
  'platform.search.query': c_platform.searchQuery,
  'platform.search.rebuild': c_platform.searchRebuild,
  'platform.security.events': c_platform.securityEvents,
  'platform.security.get': c_platform.securityGet,
  'platform.security.setSupportAccess': c_platform.securitySupportAccess,
  'platform.security.update': c_platform.securityUpdate,
  'platform.system.retryJob': c_platform.systemRetryJob,
  'platform.system.status': c_platform.systemStatus,
  'platform.task.list': c_platform.taskList,
  'platform.task.resolve': c_platform.taskResolve,
  'platform.user.assignRole': c_platform.userAssignRole,
  'platform.user.endSessions': c_platform.userEndSessions,
  'platform.user.invite': c_platform.userInvite,
  'platform.user.list': c_platform.userList,
  'platform.user.resendInvitation': c_platform.userResendInvitation,
  'platform.user.resetMfa': c_platform.userResetMfa,
  'platform.user.revokeInvitation': c_platform.userRevokeInvitation,
  'platform.user.rights': c_platform.userRights,
  'platform.user.sendPasswordReset': c_platform.userSendPasswordReset,
  'platform.user.setStatus': c_platform.userSetStatus,
  'platform.user.unassignRole': c_platform.userUnassignRole,
  'platform.view.delete': c_platform.viewDelete,
  'platform.view.list': c_platform.viewList,
  'platform.view.save': c_platform.viewSave,
  'platform.webhook.deliveries': c_platform.webhookDeliveries,
  'platform.webhook.remove': c_platform.webhookRemove,
  'platform.webhook.retry': c_platform.webhookRetry,
  'platform.webhook.save': c_platform.webhookSave,
  'pos.cash.book': c_pos.cashBook,
  'pos.cash.move': c_pos.cashMove,
  'pos.catalog.find': c_pos.catalogFind,
  'pos.export.create': c_pos.auditExportCreate,
  'pos.export.download': c_pos.auditExportDownload,
  'pos.export.list': c_pos.auditExportList,
  'pos.fiscal.elsterSheet': c_pos.fiscalElsterSheet,
  'pos.fiscal.outages': c_pos.fiscalOutageList,
  'pos.fiscal.overview': c_pos.fiscalOverview,
  'pos.fiscal.registerClient': c_pos.fiscalRegisterClient,
  'pos.fiscal.selftest': c_pos.fiscalSelfTest,
  'pos.fiscal.simulateOutage': c_pos.fiscalSimulateOutage,
  'pos.fiscal.tarExport.download': c_pos.tarExportDownload,
  'pos.fiscal.tarExport.refresh': c_pos.tarExportRefresh,
  'pos.fiscal.tarExport.start': c_pos.tarExportStart,
  'pos.fiscal.unit.setup': c_pos.fiscalUnitSetup,
  'pos.offline.caseCount': c_pos.offlineCaseCount,
  'pos.offline.cases': c_pos.offlineCases,
  'pos.offline.device.list': c_pos.offlineDeviceList,
  'pos.offline.device.pair': c_pos.offlineDevicePair,
  'pos.offline.device.reportLost': c_pos.offlineDeviceReportLost,
  'pos.offline.device.retire': c_pos.offlineDeviceRetire,
  'pos.offline.device.unblock': c_pos.offlineDeviceUnblock,
  'pos.offline.entries': c_pos.offlineEntries,
  'pos.offline.outage.document': c_pos.offlineOutageDocument,
  'pos.offline.reserve': c_pos.offlineReserve,
  'pos.offline.resolve': c_pos.offlineResolve,
  'pos.offline.settings.get': c_pos.offlineSettingsGet,
  'pos.offline.settings.update': c_pos.offlineSettingsUpdate,
  'pos.offline.snapshot': c_pos.offlineSnapshot,
  'pos.offline.submit': c_pos.offlineSubmit,
  'pos.paper.forms.issue': c_pos.paperFormsIssue,
  'pos.paper.sheet.record': c_pos.paperSheetRecord,
  'pos.paper.sheets': c_pos.paperSheets,
  'pos.pin.clear': c_pos.pinClear,
  'pos.pin.set': c_pos.pinSet,
  'pos.pin.status': c_pos.pinStatus,
  'pos.receipt.detail': c_pos.receiptDetail,
  'pos.receipt.get': c_pos.receiptGet,
  'pos.receipt.list': c_pos.receiptList,
  'pos.receipt.print': c_pos.receiptPrint,
  'pos.register.list': c_pos.registerList,
  'pos.register.quickKeys': c_pos.registerQuickKeys,
  'pos.register.save': c_pos.registerSave,
  'pos.register.setQuickKeys': c_pos.registerSetQuickKeys,
  'pos.return.create': c_pos.returnCreate,
  'pos.return.get': c_pos.returnGet,
  'pos.return.list': c_pos.returnList,
  'pos.return.print': c_pos.returnPrint,
  'pos.sale.complete': c_pos.saleComplete,
  'pos.sale.edit': c_pos.saleEdit,
  'pos.sale.park': c_pos.salePark,
  'pos.sale.resume': c_pos.saleResume,
  'pos.sale.void': c_pos.saleVoid,
  'pos.shift.approve': c_pos.shiftApprove,
  'pos.shift.close': c_pos.shiftClose,
  'pos.shift.get': c_pos.shiftGet,
  'pos.shift.list': c_pos.shiftList,
  'pos.shift.open': c_pos.shiftOpen,
  'pos.shift.overview': c_pos.shiftOverview,
  'pos.shift.todoCount': c_pos.shiftTodoCount,
  'pos.supervisor.list': c_pos.supervisorList,
  'pos.till.heartbeat': c_pos.tillHeartbeat,
  'pos.till.state': c_pos.tillState,
  'pos.voucher.get': c_pos.voucherGet,
  'pricing.approval.count': c_pricing.approvalCount,
  'pricing.campaign.cancel': c_pricing.campaignCancel,
  'pricing.campaign.channels': c_pricing.campaignChannels,
  'pricing.campaign.claim': c_pricing.campaignClaim,
  'pricing.campaign.create': c_pricing.campaignCreate,
  'pricing.campaign.get': c_pricing.campaignGet,
  'pricing.campaign.list': c_pricing.campaignList,
  'pricing.campaign.report': c_pricing.campaignReport,
  'pricing.label.add': c_pricing.labelAdd,
  'pricing.label.cancel': c_pricing.labelCancel,
  'pricing.label.list': c_pricing.labelList,
  'pricing.label.markPrinted': c_pricing.labelMarkPrinted,
  'pricing.label.pendingCount': c_pricing.labelPendingCount,
  'pricing.label.sheet': c_pricing.labelSheet,
  'pricing.markdown.create': c_pricing.markdownCreate,
  'pricing.price.bulkApply': c_pricing.priceBulkApply,
  'pricing.price.bulkPreview': c_pricing.priceBulkPreview,
  'pricing.price.end': c_pricing.priceEnd,
  'pricing.price.history': c_pricing.priceHistory,
  'pricing.price.quote': c_pricing.priceQuote,
  'pricing.price.set': c_pricing.priceSet,
  'pricing.price.upsert': c_pricing.priceUpsert,
  'pricing.priceChange.approve': c_pricing.priceChangeApprove,
  'pricing.priceChange.get': c_pricing.priceChangeGet,
  'pricing.priceChange.list': c_pricing.priceChangeList,
  'pricing.priceChange.reject': c_pricing.priceChangeReject,
  'pricing.priceChange.withdraw': c_pricing.priceChangeWithdraw,
  'pricing.priceGroup.create': c_pricing.priceGroupCreate,
  'pricing.priceGroup.deactivate': c_pricing.priceGroupDeactivate,
  'pricing.priceGroup.list': c_pricing.priceGroupList,
  'pricing.priceGroup.reactivate': c_pricing.priceGroupReactivate,
  'pricing.priceGroup.update': c_pricing.priceGroupUpdate,
  'pricing.priceList.create': c_pricing.priceListCreate,
  'pricing.priceList.deactivate': c_pricing.priceListDeactivate,
  'pricing.priceList.get': c_pricing.priceListGet,
  'pricing.priceList.list': c_pricing.priceListList,
  'pricing.priceList.prices': c_pricing.priceListPrices,
  'pricing.priceList.reactivate': c_pricing.priceListReactivate,
  'pricing.priceList.update': c_pricing.priceListUpdate,
  'pricing.promotion.adopt': c_pricing.promotionAdopt,
  'pricing.promotion.approve': c_pricing.promotionApprove,
  'pricing.promotion.create': c_pricing.promotionCreate,
  'pricing.promotion.end': c_pricing.promotionEnd,
  'pricing.promotion.get': c_pricing.promotionGet,
  'pricing.promotion.list': c_pricing.promotionList,
  'pricing.promotion.propose': c_pricing.promotionPropose,
  'pricing.promotion.reject': c_pricing.promotionReject,
  'pricing.promotion.withdraw': c_pricing.promotionWithdraw,
  'purchasing.creditNote.capture': c_purchasing.creditNoteCapture,
  'purchasing.creditNote.discard': c_purchasing.creditNoteDiscard,
  'purchasing.creditNote.get': c_purchasing.creditNoteGet,
  'purchasing.creditNote.list': c_purchasing.creditNoteList,
  'purchasing.creditNote.post': c_purchasing.creditNotePost,
  'purchasing.creditNote.print': c_purchasing.creditNotePrint,
  'purchasing.creditNote.reverse': c_purchasing.creditNoteReverse,
  'purchasing.creditNote.saveDraft': c_purchasing.creditNoteSaveDraft,
  'purchasing.creditNote.transition': c_purchasing.creditNoteTransition,
  'purchasing.invoice.adoptPrice': c_purchasing.invoiceAdoptPrice,
  'purchasing.invoice.capture': c_purchasing.invoiceCapture,
  'purchasing.invoice.decide': c_purchasing.invoiceDecide,
  'purchasing.invoice.derive': c_purchasing.invoiceDerive,
  'purchasing.invoice.discard': c_purchasing.invoiceDiscard,
  'purchasing.invoice.get': c_purchasing.invoiceGet,
  'purchasing.invoice.list': c_purchasing.invoiceList,
  'purchasing.invoice.match': c_purchasing.invoiceMatch,
  'purchasing.invoice.payables': c_purchasing.invoicePayables,
  'purchasing.invoice.post': c_purchasing.invoicePost,
  'purchasing.invoice.print': c_purchasing.invoicePrint,
  'purchasing.invoice.reverse': c_purchasing.invoiceReverse,
  'purchasing.invoice.saveDraft': c_purchasing.invoiceSaveDraft,
  'purchasing.invoice.sources': c_purchasing.invoiceSources,
  'purchasing.invoice.toCheck': c_purchasing.invoicesToCheck,
  'purchasing.invoice.transition': c_purchasing.invoiceTransition,
  'purchasing.order.approve': c_purchasing.orderApprove,
  'purchasing.order.detail': c_purchasing.orderDetail,
  'purchasing.order.discard': c_purchasing.orderDiscard,
  'purchasing.order.expected': c_purchasing.orderExpected,
  'purchasing.order.expectedToday': c_purchasing.expectedToday,
  'purchasing.order.get': c_purchasing.orderGet,
  'purchasing.order.list': c_purchasing.orderList,
  'purchasing.order.post': c_purchasing.orderPost,
  'purchasing.order.print': c_purchasing.orderPrint,
  'purchasing.order.receive': c_purchasing.orderReceive,
  'purchasing.order.reject': c_purchasing.orderReject,
  'purchasing.order.reverse': c_purchasing.orderReverse,
  'purchasing.order.saveDraft': c_purchasing.orderSaveDraft,
  'purchasing.order.send': c_purchasing.orderSend,
  'purchasing.order.sendPreview': c_purchasing.orderSendPreview,
  'purchasing.order.transition': c_purchasing.orderTransition,
  'purchasing.order.waiting': c_purchasing.ordersWaiting,
  'purchasing.order.withdraw': c_purchasing.orderWithdraw,
  'purchasing.requisition.count': c_purchasing.requisitionCount,
  'purchasing.requisition.create': c_purchasing.requisitionCreate,
  'purchasing.requisition.dismiss': c_purchasing.requisitionDismiss,
  'purchasing.requisition.list': c_purchasing.requisitionList,
  'purchasing.requisition.withdraw': c_purchasing.requisitionWithdraw,
  'purchasing.settings.get': c_purchasing.settingsGet,
  'purchasing.settings.update': c_purchasing.settingsUpdate,
  'purchasing.suggestion.order': c_purchasing.suggestionOrder,
  'purchasing.suggestion.propose': c_purchasing.suggestionPropose,
  'purchasing.supplier.overview': c_purchasing.supplierOverview,
  'reporting.dashboard.get': c_reporting.dashboardGet,
  'reporting.data.rebuild': c_reporting.dataRebuild,
  'reporting.data.status': c_reporting.dataStatus,
  'reporting.deposits.report': c_reporting.depositsReport,
  'reporting.finance.report': c_reporting.financeReport,
  'reporting.purchasing.prices': c_reporting.purchasingPrices,
  'reporting.purchasing.report': c_reporting.purchasingReport,
  'reporting.sales.documents': c_reporting.salesDocuments,
  'reporting.sales.movers': c_reporting.salesMovers,
  'reporting.sales.report': c_reporting.salesReport,
  'reporting.shrinkage.report': c_reporting.shrinkageReport,
  'reporting.stock.deadStock': c_reporting.stockDeadStock,
  'reporting.stock.expiry': c_reporting.stockExpiry,
  'reporting.stock.report': c_reporting.stockReport,
  'reporting.till.analysis': c_reporting.tillAnalysis,
  'sales.appSubscription.list': c_sales.appSubscriptionList,
  'sales.automation.get': c_sales.salesAutomationGet,
  'sales.automation.update': c_sales.salesAutomationUpdate,
  'sales.case.count': c_sales.caseCount,
  'sales.case.customer': c_sales.caseCustomer,
  'sales.case.decide': c_sales.caseDecide,
  'sales.case.decideLead': c_sales.caseDecideLead,
  'sales.case.get': c_sales.caseGet,
  'sales.case.list': c_sales.caseList,
  'sales.case.request': c_sales.caseRequest,
  'sales.channel.availability': c_sales.channelAvailability,
  'sales.channel.campaigns': c_sales.channelCampaigns,
  'sales.channel.cancelOrder': c_sales.channelCancelOrder,
  'sales.channel.capabilities': c_sales.channelCapabilities,
  'sales.channel.cases': c_sales.channelCases,
  'sales.channel.catalog': c_sales.channelCatalog,
  'sales.channel.checkCoupon': c_sales.channelCheckCoupon,
  'sales.channel.checkoutRules': c_sales.channelCheckoutRules,
  'sales.channel.claimCampaign': c_sales.channelClaimCampaign,
  'sales.channel.customerAccounts': c_sales.channelCustomerAccounts,
  'sales.channel.customers': c_sales.channelCustomers,
  'sales.channel.orderSnapshots': c_sales.channelOrderSnapshots,
  'sales.channel.orderStatus': c_sales.channelOrderStatus,
  'sales.channel.orderStatuses': c_sales.channelOrderStatuses,
  'sales.channel.reportCampaign': c_sales.channelReportCampaign,
  'sales.channel.reportCase': c_sales.channelReportCase,
  'sales.channel.reportConsents': c_sales.channelReportConsents,
  'sales.channel.reportEventDelivery': c_sales.channelReportEventDelivery,
  'sales.channel.reportEventPickup': c_sales.channelReportEventPickup,
  'sales.channel.reportFulfillment': c_sales.channelReportFulfillment,
  'sales.channel.reportNotice': c_sales.channelReportNotice,
  'sales.channel.reportPositions': c_sales.channelReportPositions,
  'sales.channel.reportSubscriptions': c_sales.channelReportSubscriptions,
  'sales.channel.reportTour': c_sales.channelReportTour,
  'sales.channel.slotLoad': c_sales.channelSlotLoad,
  'sales.channel.submitCase': c_sales.channelSubmitCase,
  'sales.channel.submitEventInquiry': c_sales.channelSubmitEventInquiry,
  'sales.channel.submitOrder': c_sales.channelSubmitOrder,
  'sales.channel.tours': c_sales.channelTours,
  'sales.checkout.get': c_sales.checkoutGet,
  'sales.checkout.load': c_sales.checkoutLoad,
  'sales.checkout.quote': c_sales.checkoutQuote,
  'sales.checkout.saveExceptions': c_sales.checkoutSaveExceptions,
  'sales.checkout.saveFreeDelivery': c_sales.checkoutSaveFreeDelivery,
  'sales.checkout.saveSettings': c_sales.checkoutSaveSettings,
  'sales.checkout.saveSlots': c_sales.checkoutSaveSlots,
  'sales.checkout.saveZones': c_sales.checkoutSaveZones,
  'sales.consignment.deliver': c_sales.consignmentDeliver,
  'sales.consignment.detail': c_sales.consignmentDetail,
  'sales.consignment.get': c_sales.consignmentGet,
  'sales.consignment.list': c_sales.consignmentList,
  'sales.consignment.open': c_sales.consignmentOpen,
  'sales.consignment.print': c_sales.consignmentPrint,
  'sales.consignment.reverse': c_sales.consignmentReverse,
  'sales.consignment.settle': c_sales.consignmentSettle,
  'sales.consignmentReturn.get': c_sales.consignmentReturnGet,
  'sales.consignmentReturn.list': c_sales.consignmentReturnList,
  'sales.consignmentReturn.print': c_sales.consignmentReturnPrint,
  'sales.coupon.create': c_sales.couponCreate,
  'sales.coupon.get': c_sales.couponGet,
  'sales.coupon.list': c_sales.couponList,
  'sales.coupon.redemptions': c_sales.couponRedemptions,
  'sales.coupon.setActive': c_sales.couponSetActive,
  'sales.coupon.update': c_sales.couponUpdate,
  'sales.credit.status': c_sales.creditStatus,
  'sales.delivery.assign': c_sales.deliveryAssign,
  'sales.delivery.billable': c_sales.deliveryBillable,
  'sales.delivery.board': c_sales.deliveryBoard,
  'sales.delivery.confirm': c_sales.deliveryConfirm,
  'sales.delivery.derive': c_sales.deliveryDerive,
  'sales.delivery.detail': c_sales.deliveryDetail,
  'sales.delivery.discard': c_sales.deliveryDiscard,
  'sales.delivery.dispatch': c_sales.deliveryDispatch,
  'sales.delivery.get': c_sales.deliveryGet,
  'sales.delivery.list': c_sales.deliveryList,
  'sales.delivery.pdf': c_sales.deliveryPdf,
  'sales.delivery.pick': c_sales.deliveryPick,
  'sales.delivery.post': c_sales.deliveryPost,
  'sales.delivery.print': c_sales.deliveryPrint,
  'sales.delivery.reverse': c_sales.deliveryReverse,
  'sales.delivery.saveDraft': c_sales.deliverySaveDraft,
  'sales.delivery.send': c_sales.deliverySend,
  'sales.delivery.sendPreview': c_sales.deliverySendPreview,
  'sales.delivery.todayCount': c_sales.deliveryTodayCount,
  'sales.event.addLoan': c_sales.eventAddLoan,
  'sales.event.assignCustomer': c_sales.eventAssignCustomer,
  'sales.event.cancel': c_sales.eventCancel,
  'sales.event.cancelLoan': c_sales.eventCancelLoan,
  'sales.event.confirm': c_sales.eventConfirm,
  'sales.event.count': c_sales.eventCount,
  'sales.event.create': c_sales.eventCreate,
  'sales.event.createQuote': c_sales.eventCreateQuote,
  'sales.event.deliver': c_sales.eventDeliver,
  'sales.event.driverStops': c_sales.eventDriverStops,
  'sales.event.get': c_sales.eventGet,
  'sales.event.handover': c_sales.eventHandover,
  'sales.event.list': c_sales.eventList,
  'sales.event.pickupForm': c_sales.eventPickupForm,
  'sales.event.recordPickup': c_sales.eventRecordPickup,
  'sales.event.saveSettings': c_sales.eventSaveSettings,
  'sales.event.settings': c_sales.eventSettings,
  'sales.event.settle': c_sales.eventSettle,
  'sales.event.settlement': c_sales.eventSettlement,
  'sales.event.shortenRental': c_sales.eventShortenRental,
  'sales.event.update': c_sales.eventUpdate,
  'sales.mailRequest.classify': c_sales.mailRequestClassify,
  'sales.mailRequest.close': c_sales.mailRequestClose,
  'sales.mailRequest.count': c_sales.mailRequestCount,
  'sales.mailRequest.createEvent': c_sales.mailRequestCreateEvent,
  'sales.mailRequest.createOrder': c_sales.mailRequestCreateOrder,
  'sales.mailRequest.get': c_sales.mailRequestGet,
  'sales.mailRequest.list': c_sales.mailRequestList,
  'sales.mailRequest.reclassify': c_sales.mailRequestReclassify,
  'sales.mailRequest.requestTransfer': c_sales.mailRequestRequestTransfer,
  'sales.mailRequest.saveSettings': c_sales.mailRequestSaveSettings,
  'sales.mailRequest.setCustomer': c_sales.mailRequestSetCustomer,
  'sales.mailRequest.settings': c_sales.mailRequestSettings,
  'sales.order.applyDelivery': c_sales.orderApplyDelivery,
  'sales.order.approve': c_sales.orderApprove,
  'sales.order.derive': c_sales.orderDerive,
  'sales.order.detail': c_sales.orderDetail,
  'sales.order.discard': c_sales.orderDiscard,
  'sales.order.get': c_sales.orderGet,
  'sales.order.list': c_sales.orderList,
  'sales.order.overview': c_sales.orderOverview,
  'sales.order.phoneCallback': c_sales.orderPhoneCallback,
  'sales.order.post': c_sales.orderPost,
  'sales.order.print': c_sales.orderPrint,
  'sales.order.reject': c_sales.orderReject,
  'sales.order.releaseCredit': c_sales.orderReleaseCredit,
  'sales.order.reserve': c_sales.orderReserve,
  'sales.order.reverse': c_sales.orderReverse,
  'sales.order.saveDraft': c_sales.orderSaveDraft,
  'sales.order.sendConfirmation': c_sales.orderSendConfirmation,
  'sales.order.sendPreview': c_sales.orderSendPreview,
  'sales.order.todoCount': c_sales.orderTodoCount,
  'sales.order.transition': c_sales.orderTransition,
  'sales.order.withdraw': c_sales.orderWithdraw,
  'sales.orderInbox.count': c_sales.orderInboxCount,
  'sales.orderInbox.list': c_sales.orderInboxList,
  'sales.phone.availability': c_sales.phoneAvailability,
  'sales.phone.cases': c_sales.phoneCases,
  'sales.phone.catalog': c_sales.phoneCatalog,
  'sales.phone.checkCoupon': c_sales.phoneCheckCoupon,
  'sales.phone.checkCustomer': c_sales.phoneCheckCustomer,
  'sales.phone.checkoutRules': c_sales.phoneCheckoutRules,
  'sales.phone.lookupOrder': c_sales.phoneLookupOrder,
  'sales.phone.quoteOrder': c_sales.phoneQuoteOrder,
  'sales.phone.slotLoad': c_sales.phoneSlotLoad,
  'sales.phone.submitCase': c_sales.phoneSubmitCase,
  'sales.phone.submitOrder': c_sales.phoneSubmitOrder,
  'sales.picking.list': c_sales.pickingList,
  'sales.pickup.handover': c_sales.pickupHandover,
  'sales.pickup.list': c_sales.pickupList,
  'sales.pickup.lookup': c_sales.pickupLookup,
  'sales.quote.discard': c_sales.quoteDiscard,
  'sales.quote.get': c_sales.quoteGet,
  'sales.quote.list': c_sales.quoteList,
  'sales.quote.post': c_sales.quotePost,
  'sales.quote.print': c_sales.quotePrint,
  'sales.quote.reverse': c_sales.quoteReverse,
  'sales.quote.saveDraft': c_sales.quoteSaveDraft,
  'sales.quote.send': c_sales.quoteSend,
  'sales.quote.sendPreview': c_sales.quoteSendPreview,
  'sales.quote.transition': c_sales.quoteTransition,
  'sales.rental.availability': c_sales.rentalAvailability,
  'sales.rental.book': c_sales.rentalBook,
  'sales.rental.calendar': c_sales.rentalCalendar,
  'sales.rental.cancel': c_sales.rentalCancel,
  'sales.rental.handOver': c_sales.rentalHandOver,
  'sales.rental.list': c_sales.rentalList,
  'sales.rental.setStock': c_sales.rentalSetStock,
  'sales.rental.takeBack': c_sales.rentalTakeBack,
  'sales.return.book': c_sales.returnBook,
  'sales.return.derive': c_sales.returnDerive,
  'sales.return.discard': c_sales.returnDiscard,
  'sales.return.get': c_sales.returnGet,
  'sales.return.list': c_sales.returnList,
  'sales.return.post': c_sales.returnPost,
  'sales.return.print': c_sales.returnPrint,
  'sales.return.reverse': c_sales.returnReverse,
  'sales.return.saveDraft': c_sales.returnSaveDraft,
  'sales.store.get': c_sales.storeGet,
  'sales.store.save': c_sales.storeSave,
  'sales.tour.board': c_sales.tourBoard,
  'sales.tour.cancel': c_sales.tourCancel,
  'sales.tour.complete': c_sales.tourComplete,
  'sales.tour.create': c_sales.tourCreate,
  'sales.tour.geocode': c_sales.tourGeocode,
  'sales.tour.get': c_sales.tourGet,
  'sales.tour.list': c_sales.tourList,
  'sales.tour.live': c_sales.tourLive,
  'sales.tour.optimize': c_sales.tourOptimize,
  'sales.tour.plan': c_sales.tourPlan,
  'sales.tour.release': c_sales.tourRelease,
  'sales.tour.saveSettings': c_sales.tourSaveSettings,
  'sales.tour.setLocation': c_sales.tourSetLocation,
  'sales.tour.setStops': c_sales.tourSetStops,
  'sales.tour.settings': c_sales.tourSettings,
  'sales.tour.update': c_sales.tourUpdate,
  'stocktaking.count.approve': c_stocktaking.countApprove,
  'stocktaking.count.cancel': c_stocktaking.countCancel,
  'stocktaking.count.differences': c_stocktaking.countDifferences,
  'stocktaking.count.enter': c_stocktaking.countEnter,
  'stocktaking.count.get': c_stocktaking.countGet,
  'stocktaking.count.inventoryList': c_stocktaking.countInventoryList,
  'stocktaking.count.list': c_stocktaking.countList,
  'stocktaking.count.plan': c_stocktaking.countPlan,
  'stocktaking.count.printSheets': c_stocktaking.countPrintSheets,
  'stocktaking.count.protocol': c_stocktaking.countProtocol,
  'stocktaking.count.recount': c_stocktaking.countRecount,
  'stocktaking.count.scopeOptions': c_stocktaking.countScopeOptions,
  'stocktaking.count.setReason': c_stocktaking.countSetReason,
  'stocktaking.count.sheet': c_stocktaking.countSheet,
  'stocktaking.count.start': c_stocktaking.countStart,
  'stocktaking.count.suspects': c_stocktaking.countSuspects,
  'stocktaking.overview.rollingDue': c_stocktaking.overviewRollingDue,
  'stocktaking.overview.running': c_stocktaking.overviewRunning,
  'stocktaking.rolling.progress': c_stocktaking.rollingProgress,
} as const

/** Alle Fachereignisse nach Namen. */
export const eventContracts = {
  'einvoice.inbound.captured': c_einvoice.inboundCaptured,
  'einvoice.inbound.parsed': c_einvoice.inboundParsed,
  'einvoice.inbound.received': c_einvoice.inboundReceived,
  'einvoice.outbound.issued': c_einvoice.outboundIssued,
  'masterdata.item.changed': c_masterdata.itemChanged,
  'masterdata.location.changed': c_masterdata.locationChanged,
  'masterdata.partner.changed': c_masterdata.partnerChanged,
  'platform.feature.changed': c_platform.featureChanged,
  'pos.offline.received': c_pos.offlineReceived,
  'pricing.campaign.changed': c_pricing.campaignChanged,
  'pricing.price.changed': c_pricing.priceChanged,
  'purchasing.creditNote.released': c_purchasing.creditNoteReleased,
  'purchasing.invoice.released': c_purchasing.invoiceReleased,
  'sales.channel.campaignRequested': c_sales.channelCampaignRequested,
  'sales.channel.caseChanged': c_sales.channelCaseChanged,
  'sales.channel.catalogChanged': c_sales.channelCatalogChanged,
  'sales.channel.checkoutRulesChanged': c_sales.channelCheckoutRulesChanged,
  'sales.channel.customerChanged': c_sales.channelCustomerChanged,
  'sales.channel.orderChanged': c_sales.channelOrderChanged,
  'sales.channel.tourChanged': c_sales.channelTourChanged,
  'sales.event.changed': c_sales.eventChanged,
  'sales.pickup.handoverRequested': c_sales.pickupHandoverRequested,
  'sales.tour.changed': c_sales.tourChanged,
  'sales.tour.positionChanged': c_sales.tourPositionChanged,
} as const

/** Manifeste aller Module (Rechtekatalog, Funktionsschalter). */
export const moduleManifests: readonly ModuleManifest[] = [m_assistant, m_deposits, m_einvoice, m_finance, m_inventory, m_masterdata, m_platform, m_pos, m_pricing, m_purchasing, m_reporting, m_sales, m_stocktaking]

export type ActionContracts = typeof actionContracts
export type ActionName = keyof ActionContracts
export type EventContracts = typeof eventContracts
export type EventName = keyof EventContracts
